import Styled from 'styled-components'

export default Styled.input`
  display: block;
  width: 100%;
  font-family: ${props => props.theme.fonts.regular};
  font-size: 1em;
  line-height: 1;
  padding: 0.75em 1em;
  font-weight: 400;
  background: ${props => props.theme.colors.white};
  border: 1px solid #dce1e4;
  border-radius: ${props => props.theme.radius};
  color: ${props => props.theme.colors.black};
  transition: .3s;

  &::placeholder {
    color: ${props => props.theme.colors.mediumGray};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.primary.shade400};
  }

  ${props => props.disabled && `
    cursor: not-allowed;
  `}
`



// WEBPACK FOOTER //
// ./src/components/Input/index.js